export const Setting = {
  ClientVersionMin: 'Minimálna verzia klienta',
  MaintenanceInProgress: 'Udržba systému',
  SettingUpdated: 'Nastavenie aktualizované',
  Title: 'Nastavenia',
};
